export default "/wp-content/plugins/pottsalat/static/images/icons/minus2.svg";